import { Prop } from 'vue-property-decorator'
import { AggregateType } from '@/entities/public/Resource/interfaces'
import { FilesProcess } from '@/components/forms/view/FilesProcess'

export default class Aggregation extends FilesProcess {
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Array, required: true }) readonly input!: Array<AggregateType>;
  @Prop({ type: Object, required: false }) readonly options!: any;
}
